module.exports = __webpack_public_path__ + "static/img/img-2.b3ddf2af.png";